

import { Client } from './types';

export const APP_NAME = "ガイアテック入金照合システム";

export const COLORS = {
  primary: '#007BFF',
  success: '#28a745',
  danger: '#e74c3c',
  warning: '#e67e22',
  secondary: '#6c757d',
  
  status: {
    exact: '#27ae60',    // Green
    withFee: '#f39c12',  // Yellow
    review: '#e67e22',   // Orange
    other: '#95a5a6',    // Gray
    unmatched: '#e74c3c' // Red
  },

  icon: {
    union: '#9b59b6',    // Purple
    other: '#e67e22',    // Orange
    monthly: '#3498db'   // Blue
  }
};

// Initial Data Seeds
export const SEED_CLIENTS: Client[] = [];